import React from "react";
import { FormConfiguration } from "../FormConfiguration";
import { FormRuntime } from "../FormRuntime";
import { BorderStyle } from "../Utilities/FormDesignConstants";
import { HStackAlignment, HStackVerticalAlignment, XHStackContainer } from "./XHStackContainer";
import { ButtonFormControl } from "../Controls/Web/ButtonFormControl";
import { DefaultOnOff } from "../Utilities/DefaultOnOff";
import { MultiLineTextEditFormControl } from "../Controls/Web/MultiLineTextEditFormControl";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration; container: XHStackContainer } {
    let ui = new FormConfiguration();
    let hstackContainer = new XHStackContainer();
    // show border so we can see
    hstackContainer.overrideFormBorderSettings = DefaultOnOff.On;

    let b = new ButtonFormControl();
    b.label = "Save";
    let b2 = new ButtonFormControl();
    b2.label = "Cancel";
    hstackContainer.add(b);
    hstackContainer.add(b2);
    hstackContainer.add(new MultiLineTextEditFormControl());
    ui.add(hstackContainer);

    return { form: ui, container: hstackContainer };
}

export const ContainerHStackStories = [
    new StoryNode(
        () => {
            let ui = getUI();

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Left",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.alignment = HStackAlignment.CENTER;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Center",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.alignment = HStackAlignment.RIGHT;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Right",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.verticalAlignment = HStackVerticalAlignment.TOP;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Top",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.verticalAlignment = HStackVerticalAlignment.MIDDLE;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Middle",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.verticalAlignment = HStackVerticalAlignment.BOTTOM;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Bottom",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.containerBorderColor = "red";
            ui.container.containerBorderRadius = 50;
            ui.container.containerBorderStyle = BorderStyle.Dashed;
            ui.container.containerBorderWidth = 10;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Override Border",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.containerBackgroundColor = "blue";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Override Background Color",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.interControlSpacing = 30;
            ui.container.innerMargin = 30;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Override Spacing",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.overrideFormBorderSettings = DefaultOnOff.DEFAULT;
            ui.form.defaultContainerBorderColor = UIStyleConstants.RED_COLOR;
            ui.form.defaultShowContainerBorder = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Border From Form",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.form.defaultContainerBackgroundColor = UIStyleConstants.YELLOW_COLOR;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Background From Form",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.form.runtimeWidth = 375;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Thin and Stack Controls",
    ),
    new StoryNode(
        () => {
            let form = new FormConfiguration();
            form.defaultContainerBorderColor = UIStyleConstants.GREEN_COLOR;
            form.defaultShowContainerBorder = true;
            form.add(new XHStackContainer());
            return <FormRuntime form={form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Horizontal Stack Container",
        "Placeholder In Runtime",
    ),
];
